import { render, staticRenderFns } from "./PointsBar.vue?vue&type=template&id=3e89569e&"
import script from "./PointsBar.vue?vue&type=script&lang=js&"
export * from "./PointsBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports